import m from 'mithril';
import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import Link from 'flarum/common/components/Link';
import tagIcon from 'flarum/tags/helpers/tagIcon';
import TagHero from 'flarum/tags/components/TagHero';
import TagsPage from 'flarum/tags/components/TagsPage';

const FALLBACK_COVER = '/assets/brand/reverser-cover.png';

// Cover resolution (no backend needed):
//   1. tag.backgroundUrl() — future-proof, kalau kolom legacy background_path
//      suatu saat diisi via API/admin.
//   2. /assets/brand/tag-<slug>.svg — vector per kategori (motif heks +
//      warna tag). Tambah file untuk tag baru, tanpa migrasi DB.
//   3. Fallback ke cover brand reverser.id.
export function coverFor(tag) {
  try {
    const custom = tag.backgroundUrl && tag.backgroundUrl();
    if (custom) return custom;
  } catch (_) {
    // abaikan, pakai pola slug di bawah
  }
  const slug = tag.slug ? tag.slug() : 'tag';
  return `/assets/brand/tag-${slug}.svg`;
}

function onCoverError(e) {
  const el = e.target;
  el.onerror = null;
  if (el.src !== FALLBACK_COVER && !el.src.endsWith(FALLBACK_COVER)) el.src = FALLBACK_COVER;
}

function avatarFor(tag) {
  const icon = tag.icon && tag.icon();
  if (icon) return <span className="RvsrTagHero-avatarIcon">{tagIcon(tag, {}, { useColor: false })}</span>;
  const letter = (tag.name() || '?').trim().charAt(0).toUpperCase();
  return <span className="RvsrTagHero-avatarLetter">{letter}</span>;
}

function statsFor(tag) {
  const parts = [];
  try {
    const n = tag.discussionCount ? tag.discussionCount() : null;
    if (typeof n === 'number') parts.push(`${n} diskusi`);
  } catch (_) {
    // abaikan
  }
  const last = tag.lastPostedAt ? tag.lastPostedAt() : null;
  if (last) parts.push(`aktif ${last.toLocaleDateString('id-ID', { day: 'numeric', month: 'short', year: 'numeric' })}`);
  return parts;
}

export default function addTagCovers() {

  // -----------------------------------------------------------------------
  // /t/:slug — header grup ala Facebook Group / subreddit:
  // cover lebar, avatar menimpa cover, nama, deskripsi, statistik.
  // -----------------------------------------------------------------------
  override(TagHero.prototype, 'view', function () {
    const tag = this.attrs.model;
    const color = tag.color ? tag.color() : null;
    const style = color ? { '--rv-tag': color, '--hero-bg': color } : undefined;

    return (
      <header className="Hero TagHero RvsrTagHero" style={style}>
        <div className="RvsrTagHero-cover">
          <img src={coverFor(tag)} alt="" aria-hidden="true" onerror={onCoverError} loading="eager" />
          <div className="RvsrTagHero-scrim" />
        </div>
        <div className="container">
          <div className="RvsrTagHero-body">
            <div className="RvsrTagHero-avatar" style={color ? { '--rv-tag': color } : undefined}>
              {avatarFor(tag)}
            </div>
            <div className="RvsrTagHero-main">
              <h1 className="Hero-title RvsrTagHero-name">
                {tag.icon && tag.icon() ? tagIcon(tag, {}, { useColor: false }) : null} {tag.name()}
              </h1>
              {tag.description() ? <div className="Hero-subtitle RvsrTagHero-desc">{tag.description()}</div> : null}
              <div className="RvsrTagHero-meta">
                <span className="RvsrTagHero-slug">r/{tag.slug()}</span>
                {statsFor(tag).map((s) => (
                  <span className="RvsrTagHero-stat">{s}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  });

  // -----------------------------------------------------------------------
  // /tags — tiap tile grup dapat strip cover di atas (klik -> halaman tag).
  // -----------------------------------------------------------------------
  override(TagsPage.prototype, 'tagTileView', function (original, tag) {
    const vdom = original(tag);
    const cover = (
      <Link className="RvsrTagTile-cover" href={app.route.tag(tag)} tabindex="-1" aria-hidden="true">
        <img src={coverFor(tag)} alt="" loading="lazy" onerror={onCoverError} />
      </Link>
    );
    if (vdom && vdom.children && vdom.children.length) vdom.children.unshift(cover);
    else if (vdom && vdom.children) vdom.children = [cover];
    return vdom;
  });
}
